// extracted by mini-css-extract-plugin
module.exports = {"searchBtn":"Button_searchBtn__3kq3q"};